export default {
  id: "blockator",
  en: {
    title: "Инноколоид Блокатор",
    subtitle1: "Информация об отправителе",
    subtitle2: "Собранная информация",
    subtitle3: "Заказ блокчейн-штампа",
    fields: {
      email: "E-mail",
      manufacturer: "Изготовитель (сайт)",
      production_date: "Месяц и год производства",
      batch: "Смена",
      expert: "Эксперт (оценка)",
      protocol: "Измерительный протокол",
      concentration: "Концентрация диоксида хлора в ppm",
      deviation: "Отклонение от ПДК",
      images: "Прикрепите фотографии, если есть (jpg, png)",
    },
    fieldsView: {
      email: "E-mail",
      manufacturer: "Изготовитель",
      production_date: "Месяц и год производства",
      batch: "Смена",
      expert: "Эксперт (оценка)",
      protocol: "Измерительный протокол",
      concentration: "Концентрация диоксида хлора в ppm",
      deviation: "Отклонение от ПДК",
      images: "Фотографии",
    },
    priceTitle: "Стоимость блокчейн-штампа составит",
    details: "Показать больше деталей",
    detailsLess: "Показать меньше деталей",
    success: "Ваш блокчейн-штамп",
    link: "Перейти на страницу блокчейн-штампа",
    agent: "Агент",
    objective: "Задача",
    token: "Токен",
    requestPrice: "Запросить услугу",
    liability: "Контракт обязательства",
    order: "Заказать блокчейн-штамп",
    error: "Проверьте пожалуйста правильность данных.",
    dragFile: "Drag & Drop your file or Browse",
    dragImages: "Drag & Drop your image files or Browse",
    view: "просмотр",
    viewImages: "показать фото",
    hideImages: "скрыть фото",
    loading: "Загрузка",
    openIpfs: "Открыть в IPFS",
    reqApprove:
      "Вам нужно одобрить дополнительную сумму для покупки блокчейн-штампа",
  },
  ru: {
    title: "Инноколоид Блокатор",
    subtitle1: "Информация об отправителе",
    subtitle2: "Собранная информация",
    subtitle3: "Заказ блокчейн-штампа",
    fields: {
      email: "E-mail",
      manufacturer: "Изготовитель (сайт)",
      production_date: "Месяц и год производства",
      batch: "Смена",
      expert: "Эксперт (оценка)",
      protocol: "Измерительный протокол",
      concentration: "Концентрация диоксида хлора в ppm",
      deviation: "Отклонение от ПДК",
      images: "Прикрепите фотографии, если есть (jpg, png)",
    },
    fieldsView: {
      email: "E-mail",
      manufacturer: "Изготовитель",
      production_date: "Месяц и год производства",
      batch: "Смена",
      expert: "Эксперт (оценка)",
      protocol: "Измерительный протокол",
      concentration: "Концентрация диоксида хлора в ppm",
      deviation: "Отклонение от ПДК",
      images: "Фотографии",
    },
    priceTitle: "Стоимость блокчейн-штампа составит",
    details: "Показать больше деталей",
    detailsLess: "Показать меньше деталей",
    success: "Ваш блокчейн-штамп",
    link: "Перейти на страницу блокчейн-штампа",
    agent: "Агент",
    objective: "Задача",
    token: "Токен",
    requestPrice: "Запросить услугу",
    liability: "Контракт обязательства",
    order: "Заказать блокчейн-штамп",
    error: "Проверьте пожалуйста правильность данных.",
    dragFile: "Drag & Drop your file or Browse",
    dragImages: "Drag & Drop your image files or Browse",
    view: "просмотр",
    viewImages: "показать фото",
    hideImages: "скрыть фото",
    loading: "Загрузка",
    openIpfs: "Открыть в IPFS",
    reqApprove:
      "Вам нужно одобрить дополнительную сумму для покупки блокчейн-штампа",
  },
};
